import { Hero } from '../components/Hero';
import { Button } from '../components/Button';
import './Store.css';

export function Store() {
  return (
    <div className="store-page">
      <Hero
        title="Store"
        subtitle="Merchandise and more coming soon"
        size="small"
      />

      <section className="store-page__content">
        <div className="container">
          <div className="store-page__coming-soon">
            <div className="store-page__icon">
              <i className="fas fa-shopping-bag"></i>
            </div>
            <h2>Coming Soon</h2>
            <p>
              We're working on creating thoughtful merchandise that embodies the
              philosophy of presence and being. Sign up to be notified when the
              store launches.
            </p>

            <div className="store-page__preview">
              <h3>What to Expect</h3>
              <div className="store-page__preview-grid">
                <div className="store-page__preview-item">
                  <i className="fas fa-book"></i>
                  <span>Signed Books</span>
                </div>
                <div className="store-page__preview-item">
                  <i className="fas fa-tshirt"></i>
                  <span>Apparel</span>
                </div>
                <div className="store-page__preview-item">
                  <i className="fas fa-mug-hot"></i>
                  <span>Mugs</span>
                </div>
                <div className="store-page__preview-item">
                  <i className="fas fa-pen"></i>
                  <span>Journals</span>
                </div>
              </div>
            </div>

            <form className="store-page__notify" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Enter your email"
                className="store-page__input"
                aria-label="Email address"
              />
              <Button type="submit">Notify Me</Button>
            </form>
          </div>

          <div className="store-page__book-cta">
            <h3>Get the Book</h3>
            <p>
              While the store is in development, you can get your copy of
              "Notation of Being" on Amazon.
            </p>
            <Button href="https://www.amazon.com" size="large">
              <i className="fab fa-amazon"></i>
              Buy on Amazon
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
